import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { MapProvider } from '../map/map-provider';
import { ZoomInState } from './zoom-in-state';

@Injectable()
export class ZoomInNotifier extends BaseNotifier<ZoomInState> {
  private static readonly INITIAL: ZoomInState = {};

  constructor(ref: Ref) {
    super(ref, ZoomInNotifier.INITIAL);
  }

  zoomIn(): void {
    const view = this.ref.watch(MapProvider).state().view;
    if (!view) return;
    view.zoom += 1;
  }
}
